import { render, staticRenderFns } from "./ModalDeletePage.vue?vue&type=template&id=9dce6ff4&"
import script from "./ModalDeletePage.vue?vue&type=script&lang=js&"
export * from "./ModalDeletePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports